import React, {useState} from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import toFaNumber from "@/lib/utils/number";
import {Button, Modal} from "antd";
import {TeacherReportStatusEnum} from "@/lib/helper/enumType";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchTeacherReports} from "@/api/teacherReports";
import RenderIf from "@/components/render-if";
import useWindowDimensions from "@/hook/useWindowDimensions";
import FileViewer from "@/lib/helper/FileViewer";
import {Paperclip} from "lucide-react";

function TeacherReportListPage(props) {

    const [openModal, setOpenModal] = useState(false)
    const showWith = 640;
    const {width} = useWindowDimensions();

    const columns = [
        {
            title: 'گزارش',
            dataIndex: 'report',
            key: 'report',
            render: (text, record) => {
                return (<div onClick={() => setOpenModal(record)}
                             className={'hover:text-blue-400 cursor-pointer line-clamp-1 max-w-64'}>{text}</div>)
            }
        },

        {
            title: 'تاریخ',
            dataIndex: 'date',
            key: 'date',
            render: (text, record) => {
                return (<div>{convertToJalaliWithFormat(text)}</div>)
            }
        },

        {
            title: width > showWith ? 'درس/فعالیت' : '',
            dataIndex: 'lesson_id',
            key: 'lesson_id',
            render: (text, record) => {
                return (
                    <>
                        <div className="max-w-64 hidden sm:flex flex-wrap gap-2">
                            <RenderIf condition={!!record?.lesson?.code}>
                                <div className={'flex gap-2'}>
                                    <span>{record?.lesson?.code}</span>
                                    <span>{record?.lesson?.topic?.title}</span>
                                </div>
                            </RenderIf>

                            <RenderIf condition={!!record?.report_type?.title}>

                                <div className={'flex gap-2'}>
                                    <span>{record?.report_type?.title}</span>

                                </div>

                            </RenderIf>

                        </div>

                    </>


                )
            }
        },

        {
            title: 'جزئیات',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (<div className={'flex gap-2'}>

                    <Button
                        size={'small'}
                        onClick={() => setOpenModal(record)}>
                        جزئیات
                    </Button>
                    <RenderIf condition={!!record?.file_id}>
                        <div className={'text-sm  '} title={'دارای فایل ضمیمه'}>

                            <Paperclip className={'w-4'}/>
                        </div>
                    </RenderIf>
                </div>)
            }
        },

    ]

    return (
        <TeacherLayout pageTitle={'زمان‌های فعالیت شما'} backTo={URLS.teacher.dashboard}>
            <Modal
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={[
                    <div className={`mt-4 flex justify-end`}>
                        <Button onClick={() => setOpenModal(false)} type={'primary'}
                        >
                            {'باشه'}
                        </Button>
                    </div>
                ]}
            >
                <table className="table">
                    <tbody>
                    <tr>
                        <th>شناسه:</th>
                        <td>{openModal?.id}</td>
                    </tr>
                    <RenderIf condition={!!openModal?.lesson?.code}>
                        <tr>
                            <th>کد درس:</th>
                            <td>{openModal?.lesson?.code}</td>
                            <td>
                                <Link to={sprintf(URLS.teacher.lessons.detail, {id: openModal?.lesson_id})}>
                                    <Button type="dashed" size={'small'}>جزئیات درس</Button>
                                </Link>
                            </td>
                        </tr>
                    </RenderIf>
                    <tr>
                        <th>تاریخ:</th>
                        <td>{convertToJalaliWithFormat(openModal?.date, "jYYYY/jMM/jDD")}</td>
                    </tr>
                    <tr>
                        <th>مدت زمان:</th>
                        <td>{toFaNumber(openModal?.diff)} <span>دقیقه</span></td>
                    </tr>


                    <tr>
                        <th>وضعیت:</th>
                        <td><span
                            className={TeacherReportStatusEnum(openModal?.status, 'color')}>{TeacherReportStatusEnum(openModal?.status)}</span>
                        </td>
                    </tr>

                    <tr>
                        <th>سرفصل:</th>
                        <td>{openModal?.lesson?.topic?.title}</td>
                    </tr>
                    <RenderIf condition={!!openModal?.report_type?.title}>
                        <tr>
                            <th>نوع:</th>
                            <td>{openModal?.report_type?.title}</td>
                        </tr>
                    </RenderIf>
                    <RenderIf condition={!!openModal?.file_id}>
                        <tr>
                            <th>فایل ضمیمه:</th>
                            <td><FileViewer fileUrl={openModal?.file?.url}/></td>
                        </tr>
                    </RenderIf>
                    <tr>
                        <th>سرفصل:</th>
                        <td>{openModal?.lesson?.topic?.title}</td>
                    </tr>
                    <tr>
                        <th>گزارش:</th>
                        <td>
                            <div
                                className={'bg-gray-100 dark:bg-gray-800 border dark:border-gray-700 border-gray-300 border-1 p-1 rounded-lg'}>{openModal?.report}</div>
                        </td>
                    </tr>


                    </tbody>
                </table>

            </Modal>

            <TableSearch
                addButton={
                    <div className="flex justify-between w-full">
                        <div></div>

                        <Link to={URLS.teacher.reports.create}>
                            <Button type='primary'>
                                ثبت گزارش عملکرد
                            </Button>
                        </Link>
                    </div>

                }
                columns={columns}
                apiFn={useApiSearchTeacherReports}

            />

        </TeacherLayout>
    );
}

export default TeacherReportListPage;